import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BookingButton from '../components/BookingButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';

const steps = [
  {
    title: 'Book Your Free Consultation',
    description: 'Pick a time that works for you on our calendar and confirm your free consultation.',
  },
  {
    title: 'Prepare for the Consultation',
    description: "We'll send you a short questionnaire to ensure all important details are gathered beforehand, ensuring an efficient and productive consultation.",
  },
  {
    title: 'Discuss Your Project',
    description: "During the consultation, we'll work with you to understand your goals and gather all the information needed to create a comprehensive project proposal.",
  },
  {
    title: 'Receive a Detailed Proposal',
    description: "After the consultation, you'll receive a project proposal outlining timelines, technologies, milestones, pricing, and more. If you're ready to proceed, simply sign and return the proposal.",
  },
  {
    title: 'Track Your Project',
    description: "Once the contract is signed, you'll get access to our project portal. You'll see updates in real time, including daily uploads of screenshots and recordings, milestones, and timelines. You can also request weekly check-ins.",
  },
  {
    title: 'Milestone Payments',
    description: "As each milestone is completed, you'll be notified and prompted to review the work and make the next payment installment, keeping your project moving forward seamlessly.",
  },
  {
    title: 'Project Completion',
    description: "Once all milestones are completed and the final payment is made, you'll receive the completed project. We'll provide thorough documentation, and if needed, a handoff meeting to ensure you're fully equipped to use or manage the project going forward.",
  },
];

const Contact = () => {
  useEffect(() => {
    document.title = 'Book a Free Consultation | Golden Coast Software Development';
    return () => {
      document.title = 'Golden Coast Software Development';
    };
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-blue-50 text-gray-900">
      <Header />

      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto space-y-16">
          <section id="book-consultation" className="bg-white rounded-2xl shadow-lg p-8 sm:p-12 text-center">
            <FontAwesomeIcon icon={faCalendarCheck} className="text-blue-600 text-5xl mb-6" />
            <h1 className="text-4xl sm:text-5xl font-extrabold">
              Book a <span className="text-blue-600">Free</span> Consultation
            </h1>
            <p className="mt-6 text-lg text-gray-600 max-w-xl mx-auto">
              Tell us about your idea on a short call. Pick any open time on our calendar, and you'll get a
              confirmation with the meeting details right away.
            </p>
            <BookingButton className="mt-8 text-lg px-8">Choose a Time</BookingButton>
            <p className="mt-4 text-sm text-gray-500">Opens our Google Calendar booking page in a new tab.</p>
          </section>

          <section id="what-to-expect">
            <h2 className="text-3xl font-bold text-center mb-10">What to Expect When Working With Us</h2>
            <ol className="relative border-l-2 border-blue-200 ml-4 space-y-10">
              {steps.map((step, index) => (
                <li key={step.title} className="pl-10 relative">
                  <span className="absolute -left-[1.1rem] top-0 flex items-center justify-center w-8 h-8 rounded-full bg-blue-600 text-white text-sm font-bold">
                    {index + 1}
                  </span>
                  <h3 className="text-xl font-bold text-blue-800 mb-2">{step.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{step.description}</p>
                </li>
              ))}
            </ol>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
